module.exports = __webpack_public_path__ + "media/images/profile-pic-upload-34095f6a.svg";